export default {
  public: { label: "Mon public", icon: "users", order: 200 },
  shows: { label: "Mes spectacles", icon: "ticket-alt", order: 300 },
  expert: { label: "Expert", icon: "compass", order: 400 }
};
